export default {
  headTags: [],
  bodyTags: [
    {
      tagName: 'script',
      attributes: {
        type: 'module',
        defer: true,
        src: '//gift-pmxpu-cdn.didipay.com/static/marketing_common_libs/adv-ui@0.1.2.js',
        crossorigin: 'anonymous',
      },
    },
  ],
}
